<template>
  <div class="login">
    <form @submit.prevent="reqCreateRoom">
      <div>
        <strong><label for="roomTitle">Room Title&nbsp;&nbsp;</label></strong>
        <input type="text" id="roomTitle" v-model="roomTitle"/>
      </div>
      <div>
        <strong>방 타입&nbsp;&nbsp;</strong>
        <input type="radio" id="conf" value="conf" v-model="roomType"/>
        <label for="conf">회의</label>
        <input type="radio" id="edu" value="edu" v-model="roomType"/>
        <label for="conf">교육</label>
        <input type="radio" id="grmlms" value="grmlms" v-model="roomType"/>
        <label for="grmlms">LMS</label>
      </div>
      <div>
        <strong><label for="beginDate">시작 날짜&nbsp;&nbsp;</label></strong>
        <input type="datetime-local" id="beginDate" v-model="beginDate"/>
      </div>
      <div>
        <strong><label for="endDate">종료 날짜&nbsp;&nbsp;</label></strong>
        <input type="datetime-local" id="endDate" v-model="endDate"/>
      </div>
      <div>
        <strong><label for="endResvDate">종료 예정 날짜&nbsp;&nbsp;</label></strong>
        <input type="datetime-local" id="endResvDate" v-model="endResvDate"/>
      </div>
      <div>
        <strong>게스트 허용&nbsp;&nbsp;</strong>
        <input type="radio" id="enterGuest" value="true" v-model="enterGuest"/>
        <label for="enterGuest">허용</label>
        <input type="radio" id="notEnterGuest" value="false" v-model="enterGuest"/>
        <label for="notEnterGuest">허용 안함</label>
      </div>
      <div>
        <strong>패스워드 사용 여부&nbsp;&nbsp;</strong>
        <input type="radio" id="definePasswd" value="true" v-model="definePasswd"/>
        <label for="definePasswd">사용</label>
        <input type="radio" id="notDefinePasswd" value="false" v-model="definePasswd"/>
        <label for="notDefinePasswd">미사용</label>
      </div>
      <div>
        <strong><label for="passwd">패스워드&nbsp;&nbsp;</label></strong>
        <input type="password" id="passwd" v-model="passwd"/>
      </div>

      <button type="submit">방 생성</button>
    </form>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import moment from 'moment'

export default {
  name: "ServiceCreateRoom",
  data() {
    return {
      roomUrlId: '',
      roomTitle: '',
      roomType: 'conf',
      beginDate: '',
      endDate: '',
      endResvDate: '',
      enterGuest: 'true',
      passwd: '',
      definePasswd: 'false'
    }
  },
  created() {
    let now = Date.now();
    this.beginDate = moment(now).format('yyyy-MM-DDTHH:mm')
    this.endDate = moment(now).add('1', 'd').format('yyyy-MM-DDTHH:mm')
    this.endResvDate = moment(now).add('23', 'h').format('yyyy-MM-DDTHH:mm')
  },
  methods: {
    ...mapActions('room', ['createRoom']),

    async reqCreateRoom() {
      if (!this.validateRoom()) {
        return;
      }

      let room = {
        roomUrlId: this.roomUrlId,
        roomTitle: this.roomTitle,
        roomType: this.roomType,
        beginDate: this.beginDate,
        endDate: this.endDate,
        endResvDate: this.endResvDate || this.endDate,
        enterGuest: this.enterGuest === 'true',
        definePasswd: this.definePasswd === 'true',
        passwd: this.passwd,
      }
      console.log('##### room ', room);
      try {
        let data = await this.createRoom(room)
        if (data && data.data && data.data.roomUrlId) {
          await this.$router.push({ path: '/' + data.data.roomUrlId })
        }
      } catch (error) {
        alert('방 생성에 실패하였습니다');
      }

    },
    validateRoom() {
      {
        // check roomUrl
        let check1 = /[^가-힣xfe0-9a-zA-Z\s-]/gi;
        let check2 = /[^(가-힣a-zA-Z0-9| |\-)]/gi;
        let ruId = this.roomTitle.trim();
        if (!ruId || check1.test(ruId) || check2.test(ruId)) {
          alert('방 이름을 다시 설정하세요');
          return false;
        }
        this.roomUrlId = this.roomTitle.trim();
      }

      {
        // check date
        if (!this.beginDate || !this.endDate) {
          alert('시작 또는 종료 날짜를 입력하세요');
          return false;
        }

        if (this.beginDate > this.endDate) {
          alert('시작날짜는 종료날짜 이전이어야 합니다.');
          return false;
        }
        if (this.endResvDate && (this.endResvDate < this.beginDate) || (this.endResvDate > this.endDate)) {
          alert('종료예정 날짜는 시작날짜 이후, 종료 시간 이전 이어야 합니다.');
          return false;
        }
        if (this.definePasswd === 'true' && this.passwd.length < 1) {
          alert('비밀번호는 공백이 될 수 없습니다');
          return false;
        }
      }
      return true;
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  form {
    display: flex;
    flex-direction: column;

    label {
      margin-top: 10px;

      &:first-of-type {
        margin-top: 0;
      }
    }

    button {
      margin-top: 10px;
      background-color: #000;
      color: #fff;
      height: 22px;
    }
  }
}
</style>